var _g, _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValveOpenInoperable = function SvgValveOpenInoperable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#valve-open-inoperable_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 19,
    r: 16,
    fill: "#F1F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 19,
    r: 15,
    stroke: "#4A7E04",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A7E04",
    fillRule: "evenodd",
    d: "M22 17.286 14 13v12l8-4.286L30 25V13z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 8,
    r: 6.125,
    fill: "#4A7E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 9.833a.65.65 0 0 0 .464-.195.67.67 0 0 0 0-.943.65.65 0 0 0-.928 0 .67.67 0 0 0 0 .943.65.65 0 0 0 .464.195m1.969-3c.174 0 .34.07.464.196a.67.67 0 0 1 .192.471v3.333c0 .177-.07.347-.192.472a.65.65 0 0 1-.464.195H33.03a.65.65 0 0 1-.464-.195.67.67 0 0 1-.192-.472V7.5c0-.177.07-.346.192-.471a.65.65 0 0 1 .464-.196h.328v-.666c0-.442.173-.866.48-1.179a1.63 1.63 0 0 1 1.789-.361 1.64 1.64 0 0 1 .888.902c.082.202.125.419.125.638v.666zM35 5.167a.98.98 0 0 0-.696.293 1 1 0 0 0-.288.707v.666h1.968v-.666c0-.266-.103-.52-.288-.707A.98.98 0 0 0 35 5.167"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "valve-open-inoperable_svg__a",
    width: 44,
    height: 44,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })))));
};
export { SvgValveOpenInoperable as ReactComponent };
export default "data:image/svg+xml,%3csvg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg filter='url(%23filter0_ddd)'%3e %3ccircle cx='22' cy='19' r='16' fill='%23F1F4F4'/%3e %3ccircle cx='22' cy='19' r='15' stroke='%234A7E04' stroke-width='2'/%3e %3c/g%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M22 17.2857L14 13L14 25L22 20.7143L30 25L30 13L22 17.2857Z' fill='%234A7E04'/%3e %3ccircle cx='35' cy='8' r='6.125' fill='%234A7E04'/%3e %3cpath d='M35 9.83333C35.174 9.83333 35.341 9.7631 35.464 9.63807C35.5871 9.51305 35.6562 9.34348 35.6562 9.16667C35.6562 8.98986 35.5871 8.82029 35.464 8.69526C35.341 8.57024 35.174 8.5 35 8.5C34.826 8.5 34.659 8.57024 34.536 8.69526C34.4129 8.82029 34.3438 8.98986 34.3438 9.16667C34.3438 9.34348 34.4129 9.51305 34.536 9.63807C34.659 9.7631 34.826 9.83333 35 9.83333ZM36.9688 6.83333C37.1428 6.83333 37.3097 6.90357 37.4328 7.0286C37.5559 7.15362 37.625 7.32319 37.625 7.5V10.8333C37.625 11.0101 37.5559 11.1797 37.4328 11.3047C37.3097 11.4298 37.1428 11.5 36.9688 11.5H33.0312C32.8572 11.5 32.6903 11.4298 32.5672 11.3047C32.4441 11.1797 32.375 11.0101 32.375 10.8333V7.5C32.375 7.32319 32.4441 7.15362 32.5672 7.0286C32.6903 6.90357 32.8572 6.83333 33.0312 6.83333H33.3594V6.16667C33.3594 5.72464 33.5322 5.30072 33.8399 4.98816C34.1476 4.67559 34.5649 4.5 35 4.5C35.2154 4.5 35.4288 4.54311 35.6278 4.62687C35.8269 4.71063 36.0078 4.83339 36.1601 4.98816C36.3124 5.14292 36.4333 5.32665 36.5157 5.52886C36.5982 5.73107 36.6406 5.9478 36.6406 6.16667V6.83333H36.9688ZM35 5.16667C34.7389 5.16667 34.4885 5.27202 34.3039 5.45956C34.1193 5.6471 34.0156 5.90145 34.0156 6.16667V6.83333H35.9844V6.16667C35.9844 5.90145 35.8807 5.6471 35.6961 5.45956C35.5115 5.27202 35.2611 5.16667 35 5.16667Z' fill='white'/%3e %3cdefs%3e %3cfilter id='filter0_ddd' x='0' y='0' width='44' height='44' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur stdDeviation='3'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e %3cfeOffset dy='2'/%3e %3cfeGaussianBlur stdDeviation='2'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/%3e %3cfeBlend mode='normal' in2='effect1_dropShadow' result='effect2_dropShadow'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e %3cfeOffset dy='2'/%3e %3cfeGaussianBlur stdDeviation='2'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/%3e %3cfeBlend mode='normal' in2='effect2_dropShadow' result='effect3_dropShadow'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect3_dropShadow' result='shape'/%3e %3c/filter%3e %3c/defs%3e %3c/svg%3e";